import styled from "styled-components/macro";

import { colors, transition } from "shared/styles/constants";

export const StyledMemberName = styled.span`
  cursor: default;

  display: inline-block;

  border-bottom: 2px solid transparent;

  &:hover {
    border-bottom-color: ${colors.grey2};

    transition: border-bottom-color ${transition.default};
  }
`;
